import React, {Component} from 'react';
import { registerReactApp, reactAppLoaded } from '../services/reactLoadTracker';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import TeaserList from '../components/TeaserList/TeaserList';
import { actions } from '../actions/actionCreators';
import PaginationControl from "../components/Filter/PaginationControl";
import Loading from "../components/Filter/Loading";
import moment from "moment";
import translate from '../services/translation';
import _ from 'lodash';

class TeaserListApp extends Component {

    static propTypes = {
        tags: PropTypes.string,
        logicalOperator: PropTypes.number,
        limit: PropTypes.number,
        allowPagination: PropTypes.bool,
        detailLink: PropTypes.string,
        detailName: PropTypes.string,
        contentTypes: PropTypes.string,
        favouriteLink: PropTypes.string,

        teasers: PropTypes.array,
        loading: PropTypes.bool,
        filter: PropTypes.object,
        pagination: PropTypes.object
    };

    componentDidMount() {
        registerReactApp();
        moment.locale(window.nezzokontikifrontend_language);
        this.props.updateFilter(
            {
                tags: this.props.tags !== '' ? this.props.tags.split(',').map((tagUid) => {
                    return {uid: tagUid};
                }) : [],
                logicalOperator: this.props.logicalOperator,
                contentTypes: this.props.contentTypes
            }, {
                ...this.props.pagination,
                limit: this.props.limit
            }
        );
    }

    triggerPagination = () => {
        this.props.paginate(this.props.filter, {
            limit: this.props.pagination.limit,
            offset: this.props.pagination.offset + this.props.limit
        });
    };

    render() {
        const pagination = this.props.allowPagination && !this.props.loading && this.props.teasers.length !== 0 && this.props.pagination.moreData ? (<PaginationControl paginate={this.triggerPagination} />) : '';
        const loadingIcon = this.props.loading ? (<Loading/>) : '';

        const detailLink = this.props.detailLink ? (
            <a className="teaserDetailLink" href={this.props.detailLink}>
                {this.props.detailName || translate('detail_name.default')}
            </a>
        ) : '';

        return (
            <div className={_(this.props.contentTypes).split(',').map(type => 'contentType' + _.upperFirst(type)).join(' ')}>
                {
                    this.props.teasers.length !== 0 ? <TeaserList teasers={this.props.teasers} favouriteLink={this.props.favouriteLink} /> : ''
                }
                {loadingIcon}
                {pagination}
                {detailLink}
            </div>
        );
    }
}

export default function createTeaserListApp(storeKey) {
    return connect(
        state => {
            return {
                teasers: state.teaser.teasers,
                loading: state.system.loading.pagination,
                filter: state.filter.filter,
                pagination: state.filter.pagination
            }
        },
        dispatch => {
            return {
                updateFilter: (filter, pagination) => dispatch(actions.filter.update(filter, pagination)),
                paginate: (filter, pagination) => dispatch(actions.filter.paginate(filter, pagination))
            };
        },
        null,
        {
            storeKey: storeKey
        }
    )(TeaserListApp);
}


// WEBPACK FOOTER //
// ./src/apps/TeaserListApp.js